import RA from 'actions/dod/dodReviewActions';
import { RSAA } from 'redux-api-middleware';
import { ajax } from 'utils/registration/formUtils';
import moment from 'moment';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

export const
dodReviewUpdateField = f => ({ type: RA.UPDATE_DOD_REVIEW_FIELD, payload: f }),
dodReviewUpdateTitle = t => ({ type: RA.UPDATE_DOD_REVIEW_TITLE, payload: t }),

dodReviewLoadCaptcha = () => ajax({
    method: 'GET',
    endpoint: ssCommonUtils.setEnvPrefix('/session/captcha'),
    headers: { 'Content-Type': 'application/json' },
    types: [
        RA.DOD_REVIEW_CAPTCHA_PENDING, {
            type: RA.DOD_REVIEW_CAPTCHA_SUCCESS,
            payload: (action, status, response) => ({ type: action, payload: response })
        },
        RA.DOD_REVIEW_CAPTCHA_FAILURE
    ]
}),

dodReviewValidateCaptcha = captcha => ({ [RSAA]: {
    method: 'POST',
    endpoint: `/session/captcha/${captcha}`,
    headers: { 'Content-Type': 'application/json' },
    types: [
        RA.DOD_REVIEW_CAPTCHA_VALIDATION_PENDING,
        RA.DOD_REVIEW_CAPTCHA_VALIDATION_SUCCESS,
        RA.DOD_REVIEW_CAPTCHA_VALIDATION_FAILURE
    ]
}}),

dodReviewResetCaptchaValidation = () => ({ type: RA.DOD_REVIEW_CAPTCHA_VALIDATION_RESET }),

dodReviewSubmit = (regData, designeeLetter, captchaInput) => {
    let data = (data => {
        let result = {};
        for(let field in data)
            for(let prop in data[field])
                if(prop.indexOf('_status') === -1 && prop.indexOf('_help') === -1 && prop !== 'id')
                    result[prop] = data[field][prop];
        return result;
    })(regData)
    data.letter = designeeLetter;

    for (let prop in data)
        if (typeof data[prop] === 'string')
            data[prop] = data[prop].trim();

    const formData = new FormData();
    formData.append('userRequest', new Blob([JSON.stringify({
            timeStamp: moment().unix(),
            originatingSystem: 'SS-Admin-Service',
            messageUuid: '9dc02909-7597-4faf-a939-788c177d3f3a',
            ssUser: {
                userName: data.userId,
                password: '',
                captcha: captchaInput,
                personalInformation: {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    middleName: data.middleName,
                    nameSuffix: null,
                    dateOfBirth: null,
                    dateOfBirthType: null,
                    passportType: null,
                    passportNumber: null,
                    passportIssueDate: null,
                    expirationDate: null,
                    issuingCountry: null,
                    city: data.city
                },
                dodAttacheInformation: {
                    embassy: data.embassy,
                    streetAddress: data.streetAddress,
                    city: data.city,
                    country: data.country,
                    stateProvince: data.stateProvince,
                    postalCode: data.zipPostal,
                    phoneNumber: data.phoneNumber
                },
                userRoles: [{
                    role: 'DOD',
                    population: 'AFSP_DOD'
                }],
                securityQuestions: [{
                    securityQuestionId: 1,
                    securityQuestionAnswer: data.born
                }, {
                    securityQuestionId: 2,
                    securityQuestionAnswer: data.food
                }, {
                    securityQuestionId: 3,
                    securityQuestionAnswer: data.color
                }],
                contactInformation: [{
                    contactType: 'EMAIL',
                    contactValue: data.emailAddress
                }]
            }
        })], { type: 'application/json' }));

    formData.append('fileUpload', data.letter, data.letter.name);

    return { [RSAA]: {
        method: 'POST',
        endpoint: '/user',
        body: formData,
        types: [
            RA.DOD_REVIEW_SUBMISSION_PENDING,
            RA.DOD_REVIEW_SUBMISSION_SUCCESS,
            RA.DOD_REVIEW_SUBMISSION_FAILURE
        ]
    }};
},

dodReviewSubmitReset = () => ({ type: RA.DOD_REVIEW_SUBMISSION_RESET });
